import { api } from './api';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    addOrderItemMy2N: build.mutation<AddOrderItemMy2NApiResponse, AddOrderItemMy2NApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}/content`,
      }),
    }),
    createBrowserPaymentMy2N: build.mutation<CreateBrowserPaymentMy2NApiResponse, CreateBrowserPaymentMy2NApiArg>({
      query: (queryArg) => ({
        body: queryArg.paymentRequest,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}/payments`,
      }),
    }),
    createOrderMy2N: build.mutation<CreateOrderMy2NApiResponse, CreateOrderMy2NApiArg>({
      query: (queryArg) => ({
        body: queryArg.orderRequest,
        method: 'POST',
        url: `/companies/${queryArg.companyId}/orders`,
      }),
    }),
    deleteOrderItemMy2N: build.mutation<DeleteOrderItemMy2NApiResponse, DeleteOrderItemMy2NApiArg>({
      query: (queryArg) => ({
        method: 'DELETE',
        url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}/content/${queryArg.orderItemId}`,
      }),
    }),
    getCompanyPaymentMy2N: build.query<GetCompanyPaymentMy2NApiResponse, GetCompanyPaymentMy2NApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/payments/${queryArg.paymentId}` }),
    }),
    getCompanyPaymentsMy2N: build.query<GetCompanyPaymentsMy2NApiResponse, GetCompanyPaymentsMy2NApiArg>({
      query: (queryArg) => ({
        params: {
          filter: queryArg.filter,
          limit: queryArg.limit,
          offset: queryArg.offset,
          order: queryArg.order,
        },
        url: `/companies/${queryArg.companyId}/payments`,
      }),
    }),
    getIntercomLicencePriceInfoMy2N: build.query<
      GetIntercomLicencePriceInfoMy2NApiResponse,
      GetIntercomLicencePriceInfoMy2NApiArg
    >({
      query: (queryArg) => ({
        params: {
          serialNumber: queryArg.serialNumber,
        },
        url: `/companies/${queryArg.companyId}/purchase/intercom`,
      }),
    }),
    getMobileVideoPriceInfoMy2N: build.query<GetMobileVideoPriceInfoMy2NApiResponse, GetMobileVideoPriceInfoMy2NApiArg>(
      {
        query: (queryArg) => ({
          params: {
            siteId: queryArg.siteId,
            taxSource: queryArg.taxSource,
          },
          url: `/companies/${queryArg.companyId}/purchase/mobile-video`,
        }),
      }
    ),
    getOrderItemMy2N: build.query<GetOrderItemMy2NApiResponse, GetOrderItemMy2NApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}/content/${queryArg.orderItemId}`,
      }),
    }),
    getOrderMy2N: build.query<GetOrderMy2NApiResponse, GetOrderMy2NApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}` }),
    }),
    getOrderResultDetailMy2N: build.query<GetOrderResultDetailMy2NApiResponse, GetOrderResultDetailMy2NApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}/results/${queryArg.orderResultId}`,
      }),
    }),
    getPaddleBillingEmailMy2N: build.query<
      GetPaddleBillingEmailMy2NApiResponse,
      GetPaddleBillingEmailMy2NApiArg
    >({
      query: (queryArg) => ({
        params: { siteId: queryArg.siteId },
        url: `/companies/${queryArg.companyId}/purchase/billing-email`,
      }),
    }),
    getPaddlePaymentInvoiceMy2N: build.query<
      GetPaddlePaymentInvoiceMy2NApiResponse,
      GetPaddlePaymentInvoiceMy2NApiArg
    >({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/purchase/payments/${queryArg.paymentId}/invoice`,
      }),
    }),
    getPaddleSetupPaymentMethodMy2N: build.query<
      GetPaddleSetupPaymentMethodMy2NApiResponse,
      GetPaddleSetupPaymentMethodMy2NApiArg
    >({
      query: (queryArg) => ({
        params: { siteId: queryArg.siteId },
        url: `/companies/${queryArg.companyId}/purchase/paddle-setup-payment-method`,
      }),
    }),
    getPaddleUpdatePaymentMethodMy2N: build.query<
      GetPaddleUpdatePaymentMethodMy2NApiResponse,
      GetPaddleUpdatePaymentMethodMy2NApiArg
    >({
      query: (queryArg) => ({
        params: { siteId: queryArg.siteId },
        url: `/companies/${queryArg.companyId}/purchase/paddle-update-payment-method`,
      }),
    }),
    getPaymentMy2N: build.query<GetPaymentMy2NApiResponse, GetPaymentMy2NApiArg>({
      query: (queryArg) => ({
        url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}/payments/${queryArg.paymentId}`,
      }),
    }),
    getPriceInfoMy2N: build.query<GetPriceInfoMy2NApiResponse, GetPriceInfoMy2NApiArg>({
      query: (queryArg) => ({
        params: {
          product: queryArg.product,
        },
        url: `/companies/${queryArg.companyId}/purchase/price-info`,
      }),
    }),
    getPromoCodeActivationDetailMy2N: build.query<
      GetPromoCodeActivationDetailMy2NApiResponse,
      GetPromoCodeActivationDetailMy2NApiArg
    >({
      query: (queryArg) => ({
        params: {
          companyId: queryArg.companyId,
          siteId: queryArg.siteId,
        },
        url: `/promo/codes/${queryArg.code}/activation`,
      }),
    }),
    getPromoPriceInfoMy2N: build.query<GetPromoPriceInfoMy2NApiResponse, GetPromoPriceInfoMy2NApiArg>({
      query: (queryArg) => ({ url: `/companies/${queryArg.companyId}/purchase/promo` }),
    }),
    getSitePaymentsMy2N: build.query<GetSitePaymentsMy2NApiResponse, GetSitePaymentsMy2NApiArg>({
      query: (queryArg) => ({
        params: {
          filter: queryArg.filter,
          limit: queryArg.limit,
          offset: queryArg.offset,
          order: queryArg.order,
        },
        url: `/companies/${queryArg.companyId}/sites/${queryArg.siteId}/payments`,
      }),
    }),
    processPaymentMy2N: build.mutation<ProcessPaymentMy2NApiResponse, ProcessPaymentMy2NApiArg>({
      query: (queryArg) => ({
        method: 'POST',
        params: {
          params: queryArg.params,
        },
        url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}/payments/${queryArg.paymentId}`,
      }),
    }),
    setPaddleBillingEmailMy2N: build.mutation<
      SetPaddleBillingEmailMy2NApiResponse,
      SetPaddleBillingEmailMy2NApiArg
    >({
      query: (queryArg) => ({
        body: queryArg.paddleBillingEmailRequest,
        method: 'PUT',
        params: { siteId: queryArg.siteId },
        url: `/companies/${queryArg.companyId}/purchase/billing-email`,
      }),
    }),
    updateOrderItemMy2N: build.mutation<UpdateOrderItemMy2NApiResponse, UpdateOrderItemMy2NApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}/content/${queryArg.orderItemId}`,
      }),
    }),
    updateOrderMy2N: build.mutation<UpdateOrderMy2NApiResponse, UpdateOrderMy2NApiArg>({
      query: (queryArg) => ({
        body: queryArg.baseOrderRequest,
        method: 'PUT',
        url: `/companies/${queryArg.companyId}/orders/${queryArg.orderId}`,
      }),
    }),
    verifyVatMy2N: build.mutation<VerifyVatMy2NApiResponse, VerifyVatMy2NApiArg>({
      query: (queryArg) => ({ method: 'HEAD', url: `/companies/${queryArg.companyId}/purchase/vat` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as be4feMy2nApi };
export type GetOrderItemMy2NApiResponse = /** status 200 successful operation */
  | IntercomOrderItem
  | MobileVideoOrderItem
  | PromoOrderItem;
export type GetOrderItemMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of an order */
  orderId: string;
  /** Id of an item in order */
  orderItemId: number;
};
export type UpdateOrderItemMy2NApiResponse = /** status 200 successful operation */
  | IntercomOrderItem
  | MobileVideoOrderItem
  | PromoOrderItem;
export type UpdateOrderItemMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of an order */
  orderId: string;
  /** Id of an item in order */
  orderItemId: number;
  body: IntercomOrderItemRequest | MobileVideoOrderItemRequest | PromoOrderItemRequest;
};
export type DeleteOrderItemMy2NApiResponse = unknown;
export type DeleteOrderItemMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of an order */
  orderId: string;
  /** Id of an item in order */
  orderItemId: number;
};
export type GetOrderMy2NApiResponse = /** status 200 successful operation */ Order;
export type GetOrderMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of an order */
  orderId: string;
};
export type UpdateOrderMy2NApiResponse = /** status 200 successful operation */ Order;
export type UpdateOrderMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of an order */
  orderId: string;
  baseOrderRequest: BaseOrderRequest;
};
export type GetPaymentMy2NApiResponse = /** status 200 successful operation */ Payment;
export type GetPaymentMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of an order */
  orderId: string;
  /** Id of a payment */
  paymentId: string;
};
export type ProcessPaymentMy2NApiResponse = /** status 200 successful operation */ Payment;
export type ProcessPaymentMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of an order */
  orderId: string;
  /** Id of a payment */
  paymentId: string;
  /** Parameters from third party payment gateway */
  params?: {
    [key: string]: string[];
  };
};
export type CreateBrowserPaymentMy2NApiResponse = /** status 201 successful operation */ RedirectData;
export type CreateBrowserPaymentMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of an order */
  orderId: string;
  paymentRequest: PaymentRequest;
};
export type AddOrderItemMy2NApiResponse = /** status 201 successful operation */
  | IntercomOrderItem
  | MobileVideoOrderItem
  | PromoOrderItem;
export type AddOrderItemMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of an order */
  orderId: string;
  body: IntercomOrderItemRequest | MobileVideoOrderItemRequest | PromoOrderItemRequest;
};
export type CreateOrderMy2NApiResponse = /** status 201 successful operation */ Order;
export type CreateOrderMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  orderRequest: OrderRequest;
};
export type VerifyVatMy2NApiResponse = unknown;
export type VerifyVatMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
};
export type GetPromoCodeActivationDetailMy2NApiResponse = /** status 200 successful operation */ ActivationDetail;
export type GetPromoCodeActivationDetailMy2NApiArg = {
  /** Activation code */
  code: string;
  /** Company ID used for activation of the code */
  companyId: number;
  /** Site ID used for activation of the code */
  siteId?: number;
};
export type GetSitePaymentsMy2NApiResponse = /** status 200 successful operation */ PaymentPage;
export type GetSitePaymentsMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  /** Maximum number of records to be returned. Default 50, maximum 1000 */
  limit?: number;
  /** Return the results with this offset, first record has zero offset. */
  offset?: number;
  /** Text to filter the results with. Filter columns [id, uuid, email, firstName, lastName] */
  filter?: string;
  /** Name of the attribute to sort the results with. If it is prepended with "-", the order is reversed. Order columns [dateCreated, invoiceNumber, lastUpdated, processedTime]  */
  order?: string[];
};
export type GetPromoPriceInfoMy2NApiResponse = /** status 200 successful operation */ PriceInfo;
export type GetPromoPriceInfoMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
};
export type GetPaddlePaymentInvoiceMy2NApiResponse = /** status 200 successful operation */ PaddleInvoice;
export type GetPaddlePaymentInvoiceMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** UUID of the payment whose Paddle invoice is requested. */
  paymentId: string;
};
export type GetPaddleBillingEmailMy2NApiResponse = /** status 200 successful operation */ PaddleBillingEmail;
export type GetPaddleBillingEmailMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
};
export type SetPaddleBillingEmailMy2NApiResponse = /** status 200 successful operation */ PaddleBillingEmailUpdateResult;
export type SetPaddleBillingEmailMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
  paddleBillingEmailRequest: PaddleBillingEmailRequest;
};
export type GetPaddleUpdatePaymentMethodMy2NApiResponse = /** status 200 successful operation */ PaddleCheckoutSession;
export type GetPaddleUpdatePaymentMethodMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
};
export type GetPaddleSetupPaymentMethodMy2NApiResponse = /** status 200 successful operation */ PaddleCheckoutSession;
export type GetPaddleSetupPaymentMethodMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Numeric siteId of the Site to perform action with. */
  siteId: number;
};
export type GetPriceInfoMy2NApiResponse = /** status 200 successful operation */ PriceInfo;
export type GetPriceInfoMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Optional filter for prices */
  product?: ProductAvailable[];
};
export type GetMobileVideoPriceInfoMy2NApiResponse = /** status 200 successful operation */ MobileVideoPriceInfo;
export type GetMobileVideoPriceInfoMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of a site */
  siteId: number;
  /** Source used to calculate VAT. Defaults to DEFAULT (HEG-sourced VAT) when omitted. */
  taxSource?: 'DEFAULT' | 'PADDLE';
};
export type GetIntercomLicencePriceInfoMy2NApiResponse = /** status 200 successful operation */ IntercomPriceInfo;
export type GetIntercomLicencePriceInfoMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Serial number of a 2N device */
  serialNumber: string;
};
export type GetCompanyPaymentMy2NApiResponse = /** status 200 successful operation */ Payment;
export type GetCompanyPaymentMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of a payment */
  paymentId: string;
};
export type GetCompanyPaymentsMy2NApiResponse = /** status 200 successful operation */ PaymentPage;
export type GetCompanyPaymentsMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Maximum number of records to be returned. Default 50, maximum 1000 */
  limit?: number;
  /** Return the results with this offset, first record has zero offset. */
  offset?: number;
  /** Text to filter the results with. Filter columns [id, uuid, email, firstName, lastName] */
  filter?: string;
  /** Name of the attribute to sort the results with. If it is prepended with "-", the order is reversed. Order columns [dateCreated, invoiceNumber, lastUpdated, processedTime]  */
  order?: string[];
};
export type GetOrderResultDetailMy2NApiResponse = /** status 200 successful operation */
  | IntercomOrderResultDetail
  | PromoOrderResultDetail;
export type GetOrderResultDetailMy2NApiArg = {
  /** Numeric companyId of the Company to perform action with. */
  companyId: number;
  /** Id of an order */
  orderId: string;
  /** Id of an order result */
  orderResultId: number;
};
export type ProductType = 'IP_INTERCOM' | 'MOBILE_VIDEO' | 'PROMO' | 'ELECTRONIC_LOCK';
export type OrderItem = {
  type: ProductType;
};
export type IntercomLicenceProduct =
  | 'LICENCE_NFC_ACCESS_UNIT'
  | 'LICENCE_G729'
  | 'LICENCE_ENHANCED_SECURITY'
  | 'LICENCE_ENHANCED_AUDIO'
  | 'LICENCE_ENHANCED_VIDEO'
  | 'LICENCE_ENHANCED_INTEGRATION'
  | 'LICENCE_INFORMCAST'
  | 'LICENCE_MS_TEAMS'
  | 'LICENCE_NFC'
  | 'LICENCE_ACCESS_UNIT_LIFT_MODULE'
  | 'LICENCE_INTERCOM_LIFT_MODULE'
  | 'LICENCE_GOLD';
export type OrderType = 'SINGLE' | 'RECURRING';
export type IntercomOrderItem = OrderItem & {
  product: IntercomLicenceProduct;
  serialNumber: string;
  subjectId: number;
  id: number;
  externalId?: string;
  vatRate: number;
  price: number;
  priceVat: number;
  unitFullPrice: number;
  unitFullPriceVat: number;
  unitDiscountedPrice: number;
  unitDiscountedPriceVat: number;
  discount?: number;
  orderType: OrderType;
};
export type MobileVideoProductAvailable =
  | 'MOBILE_VIDEO_MONTH'
  | 'MOBILE_VIDEO_YEAR'
  | 'APARTMENT_MOBILE_VIDEO_MONTH'
  | 'APARTMENT_MOBILE_VIDEO_YEAR';
export type MobileVideoPurchaseType = 'EXTENSION' | 'EXPANSION';
export type SiteDetail = {
  id?: number;
  name: string;
  my2nId?: string;
};
export type MobileVideoOrderItem = OrderItem & {
  product: MobileVideoProductAvailable;
  licences: number;
  percentage: number;
  purchase: number;
  purchaseType: MobileVideoPurchaseType;
  site: SiteDetail;
  unitPrice: number;
  unitPriceVat: number;
  id: number;
  externalId?: string;
  vatRate: number;
  price: number;
  priceVat: number;
  unitFullPrice: number;
  unitFullPriceVat: number;
  unitDiscountedPrice: number;
  unitDiscountedPriceVat: number;
  discount?: number;
  orderType: OrderType;
};
export type PromoProduct =
  | 'MOBILE_VIDEO_POOL_CREDIT'
  | 'MOBILE_VIDEO_POOL_CREDIT_YEAR_APARTMENT'
  | 'MOBILE_VIDEO_POOL_CREDIT_10_YEAR_APARTMENT'
  | 'MOBILE_VIDEO_POOL_CREDIT_YEAR_STANDARD'
  | 'DORMAKABA_LOCK_CREDIT_ANNUAL'
  | 'DORMAKABA_LOCK_CREDIT_10_YEARS';
export type BatchConfiguration = {
  product: PromoProduct;
};
export type MobileVideoCreditConfiguration = BatchConfiguration & {
  credit: number;
};
export type MobileVideoYearlySubscriptionConfigurationApartment = BatchConfiguration & {
  devices: number;
  years: number;
};
export type MobileVideoYearlySubscriptionConfigurationStandard = BatchConfiguration & {
  devices: number;
  years: number;
};
export type MobileVideoYearlySubscriptionConfigurationTenYearApartment = BatchConfiguration & {
  devices: number;
};
export type PromoOrderItem = OrderItem & {
  product: PromoProduct;
  name?: string;
  size: number;
  utm?: string;
  id: number;
  externalId?: string;
  vatRate: number;
  price: number;
  priceVat: number;
  unitFullPrice: number;
  unitFullPriceVat: number;
  unitDiscountedPrice: number;
  unitDiscountedPriceVat: number;
  discount?: number;
  orderType: OrderType;
  configuration:
    | MobileVideoCreditConfiguration
    | MobileVideoYearlySubscriptionConfigurationApartment
    | MobileVideoYearlySubscriptionConfigurationStandard
    | MobileVideoYearlySubscriptionConfigurationTenYearApartment;
};
export type OrderItemRequest = {
  type: ProductType;
};
export type IntercomLicenceProductAvailable = 'LICENCE_INFORMCAST' | 'LICENCE_MS_TEAMS' | 'LICENCE_GOLD';
export type Discount = {
  percentage: number;
};
export type IntercomOrderItemRequest = OrderItemRequest & {
  serialNumber: string;
  licence: IntercomLicenceProductAvailable;
  externalId?: string;
  discount?: Discount;
};
export type MobileVideoOrderItemRequest = OrderItemRequest & {
  siteId: number;
  product?: MobileVideoProductAvailable;
  externalId?: string;
  discount?: Discount;
};
export type PromoConfigurationRequest = object;
export type PromoProductAvailableFixedYears =
  | 'MOBILE_VIDEO_POOL_CREDIT_10_YEAR_APARTMENT'
  | 'DORMAKABA_LOCK_CREDIT_10_YEARS';
export type PromoConfigurationRequestOneOf = PromoConfigurationRequest & {
  product: PromoProductAvailableFixedYears;
  devices: number;
};
export type PromoProductAvailable =
  | 'MOBILE_VIDEO_POOL_CREDIT_YEAR_APARTMENT'
  | 'MOBILE_VIDEO_POOL_CREDIT_YEAR_STANDARD'
  | 'DORMAKABA_LOCK_CREDIT_ANNUAL';
export type PromoConfigurationRequestOneOf1 = PromoConfigurationRequest & {
  product: PromoProductAvailable;
  years: number;
  devices: number;
};
export type PromoOrderItemRequest = OrderItemRequest & {
  name?: string;
  size?: number;
  utm?: string;
  externalId?: string;
  discount?: Discount;
  configuration?: PromoConfigurationRequestOneOf | PromoConfigurationRequestOneOf1;
};
export type Currency = 'EUR' | 'USD';
export type PaymentMethod = 'GP_WEBPAY' | 'INVOICE' | 'PADDLE';
export type OrderResult = {
  type: ProductType;
};
export type IntercomOrderResult = OrderResult & {
  serialNumber: string;
  products: IntercomLicenceProduct[];
  licenceKeys: string[];
  id: number;
};
export type PromoOrderResult = OrderResult & {
  name: string;
  id: number;
};
export type Order = {
  id: string;
  externalId?: string;
  orderNumber: number;
  currency: Currency;
  customerOrderNumber?: string;
  chargeVat: boolean;
  dateCreated: string;
  paymentMethod: PaymentMethod;
  price: number;
  priceVat: number;
  orderContent: (IntercomOrderItem | MobileVideoOrderItem | PromoOrderItem)[];
  orderResults: (IntercomOrderResult | PromoOrderResult)[];
};
export type BaseOrderRequest = {
  externalId?: string;
  customerOrderNumber?: string;
  paymentMethod: PaymentMethod;
};
export type PurchaseState =
  | 'CREATED'
  | 'CONFIRMED'
  | 'COMPLETED'
  | 'FAILED'
  | 'PROCESSING'
  | 'CANCELLING'
  | 'PAID'
  | 'CANCELLED'
  | 'DELIVERED'
  | 'INVOICE_ISSUED'
  | 'BEFORE_COMPLETION';
export type PaymentResult = {
  paymentMethod: string;
};
export type GpWebpayPaymentResult =
  | 'OK'
  | 'NOT_PROCESSED'
  | 'SESSION_EXPIRED'
  | 'USER_ERROR'
  | 'CARD_ERROR'
  | 'CARD_ISSUER_ERROR'
  | 'GATEWAY_ERROR'
  | 'MY2N_WARN'
  | 'MY2N_ERROR';
export type GpWebpayPaymentResultDetail = PaymentResult & {
  paymentResult?: GpWebpayPaymentResult;
  primaryCode?: number;
  secondaryCode?: number;
};
export type InvoicePaymentResult = 'OK' | 'NOT_PROCESSED' | 'CREDIT_LIMIT_EXCEEDED' | 'ERROR';
export type InvoicePaymentResultDetail = PaymentResult & {
  paymentResult?: InvoicePaymentResult;
};
export type Payment = {
  id: string;
  externalId?: string;
  paymentNumber: number;
  invoiceNumber?: string;
  dateCreated: string;
  lastUpdated: string;
  processedTime?: string;
  purchaseState: PurchaseState;
  purchaseOrder: Order;
  purchasePaymentResult: PaymentResult | GpWebpayPaymentResultDetail | InvoicePaymentResultDetail;
};
export type RedirectData = {
  paymentId: string;
  method: PaymentMethod;
  redirectUrl?: string;
  parameters?: {
    [key: string]: object;
  };
};
export type PaymentRequest = {
  redirectUrl?: string;
  siteId?: number | null;
};
export type OrderRequest = {
  content: (IntercomOrderItemRequest | MobileVideoOrderItemRequest | PromoOrderItemRequest)[];
  externalId?: string;
  customerOrderNumber?: string;
  paymentMethod: PaymentMethod;
};
export type StandardLicenceModelState =
  | 'INITIAL'
  | 'TRIAL_ACTIVE'
  | 'TRIAL_EXPIRED'
  | 'STANDARD'
  | 'STANDARD_RENEWAL'
  | 'STANDARD_EXPIRED'
  | 'TEMPORARY'
  | 'PROCESSING_PAYMENT';
export type ActivationContext = {
  status: StandardLicenceModelState;
  licencesPool: number;
  consumption: number;
  validityTo: string;
  expiration?: string;
};
export type ProductEnum = 'IP_INTERCOM' | 'MOBILE_VIDEO' | 'PROMO' | 'ELECTRONIC_LOCK';
export type Activation = {
  initialConsumption: number;
  licencesCount: number;
  unlicensedCount: number;
  licencesPool: number;
  nextPayment?: number;
  validityTo: string;
  expiration?: string;
  product: ProductEnum;
};
export type ActivationDetail = {
  context: ActivationContext;
  activations: Activation[];
  configuration:
    | MobileVideoCreditConfiguration
    | MobileVideoYearlySubscriptionConfigurationApartment
    | MobileVideoYearlySubscriptionConfigurationStandard
    | MobileVideoYearlySubscriptionConfigurationTenYearApartment;
};
export type Sort = {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
};
export type Pageable = {
  sort: Sort;
  offset: number;
  pageSize: number;
  pageNumber: number;
  paged: boolean;
  unpaged: boolean;
};
export type PaymentPage = {
  content?: Payment[];
  totalElements: number;
  last: boolean;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  numberOfElements: number;
  sort: Sort;
  empty: boolean;
  pageable: Pageable;
};
export type Price = {
  unitFullPrice: number;
  unitFullPriceVat: number;
  vatRate: number;
  chargeVat: boolean;
};
export type ProductDetail = {
  type: string;
};
export type IntercomProductDetail = ProductDetail & {
  code: number;
  products?: IntercomLicenceProduct[];
};
export type MobileVideoProductDetail = ProductDetail & {
  period: string;
};
export type PriceInfo = {
  prices: {
    [key: string]: Price;
  };
  products: {
    [key: string]: ProductDetail | IntercomProductDetail | MobileVideoProductDetail;
  };
  chargeVat: boolean;
  currency: Currency;
  creditLimit: number;
  canBeInvoiced: boolean;
  paymentTerm?: string;
};
export type ProductAvailable =
  | 'LICENCE_INFORMCAST'
  | 'LICENCE_MS_TEAMS'
  | 'LICENCE_GOLD'
  | 'MOBILE_VIDEO_MONTH'
  | 'MOBILE_VIDEO_YEAR'
  | 'APARTMENT_MOBILE_VIDEO_MONTH'
  | 'APARTMENT_MOBILE_VIDEO_YEAR'
  | 'MOBILE_VIDEO_POOL_CREDIT_YEAR_APARTMENT'
  | 'MOBILE_VIDEO_POOL_CREDIT_10_YEAR_APARTMENT'
  | 'MOBILE_VIDEO_POOL_CREDIT_YEAR_STANDARD'
  | 'DORMAKABA_LOCK_CREDIT_ANNUAL'
  | 'DORMAKABA_LOCK_CREDIT_10_YEARS';
export type MobileVideoProductPurchaseCalculation = {
  chargeVat: boolean;
  unitFullPrice: number;
  unitFullPriceVat: number;
  vatRate: number;
  purchase: number;
  multiplier: number;
  percentage: number;
  licencesPool: number;
  licences: number;
  price: number;
  priceVat: number;
};
export type NextPayment = {
  date: string;
  calculation: MobileVideoProductPurchaseCalculation;
};
export type MobileVideoPurchaseCalculation = {
  calculation: {
    [key: string]: MobileVideoProductPurchaseCalculation;
  };
  nextPayment: {
    [key: string]: NextPayment;
  };
  regularPayment: {
    [key: string]: MobileVideoProductPurchaseCalculation;
  };
  purchaseType: MobileVideoPurchaseType;
  monthPercentage: number;
};
export type MobileVideoPriceInfo = {
  calculation: MobileVideoPurchaseCalculation;
  prices: {
    [key: string]: Price;
  };
  products: {
    [key: string]: ProductDetail | IntercomProductDetail | MobileVideoProductDetail;
  };
  chargeVat: boolean;
  currency: Currency;
  creditLimit: number;
  canBeInvoiced: boolean;
  paymentTerm?: string;
};
export type IntercomPriceCalculation = {
  serialNumber: string;
  deviceType?: string;
  capable: IntercomLicenceProductAvailable[];
  purchased: IntercomLicenceProductAvailable[];
  available: IntercomLicenceProductAvailable[];
};
export type IntercomPriceInfo = {
  calculation: IntercomPriceCalculation;
  prices: {
    [key: string]: Price;
  };
  products: {
    [key: string]: ProductDetail | IntercomProductDetail | MobileVideoProductDetail;
  };
  chargeVat: boolean;
  currency: Currency;
  creditLimit: number;
  canBeInvoiced: boolean;
  paymentTerm?: string;
};
export type IntercomOrderResultDetail = {
  type?: ProductType;
  serialNumber: string;
  products: IntercomLicenceProduct[];
  licenceKeys: string[];
  id: number;
};
export type PromoChannel = 'AXIS' | 'PROMO' | 'PURCHASE';
export type PromoUser = {
  id: number;
  name?: string;
  email?: string;
};
export type CodeState = 'CANCELLED' | 'CREATED' | 'EXPIRED' | 'LOCKED' | 'USED';
export type PromoCode = {
  code: string;
  state: CodeState;
  closedAt?: string;
};
export type PromoOrderResultDetail = {
  type?: ProductType;
  name: string;
  orderItemId: number;
  externalId?: string;
  notes?: string;
  invoice?: string;
  utm?: string;
  dateCreated: string;
  validityTo: string;
  channel: PromoChannel;
  stats: {
    [key: string]: number;
  };
  createdBy?: PromoUser;
  codes: PromoCode[];
  id: number;
  configuration:
    | MobileVideoCreditConfiguration
    | MobileVideoYearlySubscriptionConfigurationApartment
    | MobileVideoYearlySubscriptionConfigurationStandard
    | MobileVideoYearlySubscriptionConfigurationTenYearApartment;
};
export type PaddleInvoice = {
  url?: string;
};
export type PaddleBillingEmail = {
  email?: string | null;
  editable?: boolean;
};
export type PaddleBillingEmailRequest = {
  email: string;
};
export type PaddleBillingEmailUpdateResult = {
  paymentMethodUpdateRequired?: boolean;
};
export type PaddleCheckoutSession = {
  transactionId?: string;
  clientToken?: string;
  environment?: string;
};
export const {
  useAddOrderItemMy2NMutation,
  useCreateBrowserPaymentMy2NMutation,
  useCreateOrderMy2NMutation,
  useDeleteOrderItemMy2NMutation,
  useGetCompanyPaymentMy2NQuery,
  useGetCompanyPaymentsMy2NQuery,
  useGetIntercomLicencePriceInfoMy2NQuery,
  useGetMobileVideoPriceInfoMy2NQuery,
  useGetOrderItemMy2NQuery,
  useGetOrderMy2NQuery,
  useGetOrderResultDetailMy2NQuery,
  useGetPaddleBillingEmailMy2NQuery,
  useGetPaddleSetupPaymentMethodMy2NQuery,
  useGetPaddleUpdatePaymentMethodMy2NQuery,
  useGetPaymentMy2NQuery,
  useGetPriceInfoMy2NQuery,
  useGetPromoCodeActivationDetailMy2NQuery,
  useGetPromoPriceInfoMy2NQuery,
  useGetSitePaymentsMy2NQuery,
  useLazyGetCompanyPaymentMy2NQuery,
  useLazyGetCompanyPaymentsMy2NQuery,
  useLazyGetIntercomLicencePriceInfoMy2NQuery,
  useLazyGetMobileVideoPriceInfoMy2NQuery,
  useLazyGetOrderItemMy2NQuery,
  useLazyGetOrderMy2NQuery,
  useLazyGetOrderResultDetailMy2NQuery,
  useLazyGetPaddleBillingEmailMy2NQuery,
  useLazyGetPaddlePaymentInvoiceMy2NQuery,
  useLazyGetPaddleSetupPaymentMethodMy2NQuery,
  useLazyGetPaddleUpdatePaymentMethodMy2NQuery,
  useLazyGetPaymentMy2NQuery,
  useLazyGetPriceInfoMy2NQuery,
  useLazyGetPromoCodeActivationDetailMy2NQuery,
  useLazyGetPromoPriceInfoMy2NQuery,
  useLazyGetSitePaymentsMy2NQuery,
  useProcessPaymentMy2NMutation,
  useSetPaddleBillingEmailMy2NMutation,
  useUpdateOrderItemMy2NMutation,
  useUpdateOrderMy2NMutation,
  useVerifyVatMy2NMutation,
} = injectedRtkApi;
